/* reports: отчёт «Откуда клиенты» (reports-ads.tsx, reports.tsx). Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "Откуда клиенты": "Where clients come from",
  "Откуда клиенты: реклама, источники, каналы": "Where clients come from: ads, sources, channels",
  "Сколько новых контактов пришло с какой рекламы — по площадкам (Google Ads, Meta и другие) и кампаниям, из какого источника Zoho CRM и по какому каналу они впервые обратились. По дням, неделям или месяцам за любой период; выгрузка в CSV.":
    "How many new contacts came from which ads — by platform (Google Ads, Meta and others) and campaign, from which Zoho CRM source and through which channel they first reached out. By day, week or month for any period; CSV export.",
  "живые данные": "live data",
  "не зафиксировано": "not recorded",
  "30 дней": "30 days",
  "90 дней": "90 days",
  "Полгода": "6 months",
  "Этот год": "This year",
  "12 месяцев": "12 months",
  "Всё время": "All time",
  "неделя с {day}": "week of {day}",
  "с": "from",
  "по": "to",
  "Детализация": "Granularity",
  "Авто": "Auto",
  "По дням": "By day",
  "По неделям": "By week",
  "По месяцам": "By month",
  "другие площадки": "other platforms",
  "другие кампании": "other campaigns",
  "Площадки:": "Platforms:",
  "график и таблицы — только по выбранным": "chart and tables — selected only",
  "Новые контакты по кампаниям: {platform}": "New contacts by campaign: {platform}",
  "без рекламных меток": "no ad marks",
  "Дата прихода: первое обращение — {a}, первая сделка CRM — {b}, создание карточки — {c}.": "Arrival date: first contact — {a}, first CRM deal — {b}, card creation — {c}.",
  "Новые контакты по рекламе": "New contacts by advertising",
  "Контактов пришло": "Contacts arrived",
  "С рекламы": "From ads",
  "Без рекламных меток": "No ad marks",
  "За выбранный период новых контактов нет.": "No new contacts in the selected period.",
  "Площадки и кампании": "Platforms and campaigns",
  "клик по площадке раскрывает кампании": "click a platform to expand its campaigns",
  "Площадка / кампания": "Platform / campaign",
  "кампаний": "campaign|campaigns",
  "кампания не указана": "campaign not specified",
  "Источник в Zoho CRM (Lead Source)": "Source in Zoho CRM (Lead Source)",
  "не записан": "not recorded",
  "Канал первого обращения": "First contact channel",
  "Метки берутся из Zoho CRM (контакт, первая сделка, лид с тем же телефоном или почтой) — те же, что в блоке «Откуда клиент» карточки контакта.":
    "Marks come from Zoho CRM (the contact, the first deal, a lead with the same phone or email) — the same as in the “Where the client came from” block of the contact card.",
  "Нет данных.": "No data.",
  "Показать все ({n})": "Show all ({n})",
};
export default d;
